import { Suspense, lazy } from "react";

// The pages use the platform's own page parts, which themselves read this
// package. Loading them on demand keeps the package entry free of that
// circle, and off the first-paint bundle.
const List = lazy(() => import("./BucketsPage").then((m) => ({ default: m.BucketsPage })));
const One = lazy(() => import("./BucketPage").then((m) => ({ default: m.BucketPage })));

const BucketRoute = (props) => (
  <Suspense fallback={null}>
    <One {...props} />
  </Suspense>
);

export const BucketsRoute = (props) => (
  <Suspense fallback={null}>
    <List {...props} />
  </Suspense>
);

BucketsRoute.title = "Buckets";
BucketsRoute.path = "/buckets";
BucketsRoute.exact = true;
BucketsRoute.routes = () => [{ title: "Bucket", path: "/:id(\\d+)", exact: true, component: BucketRoute }];
